export default function displayPageHeader(pageRoute) {
  switch (pageRoute) {
    case '/account':
      return 'Your Account';
    case '/create-account/step-3':
      return 'Select a purpose to get started';
    case '/transfer-history':
      return 'Payments';
    default:
      return '';
  }
}
